import React from 'react';
import PropTypes from 'prop-types';
import Config from '../../config';

// Utils
import getWindow from 'Utils/get-window';
import ObjectUtil from 'Utils/object-util';

// Components
import WebLink from './web-link';
import DoNotSellModal from '../modals/do-not-sell';

import withT from 'ComponentLibrary/hocs/withT';

import connector from 'Utils/connector';
import connectModal from 'Webapp/shared/app/connectors/connectModal';
import connectAuthentication from 'Webapp/shared/app/connectors/connectAuthentication';

const DNS_LINK_INCLUDE_PROPS = ['href', 'name', 'className', 'onClick'];

function DoNotSelLink(props) {
  const { auto, label, isAuthenticated, showModal, onClick, t } = props;

  const showDoNotSell = (e) => {
    if (e) {
      e.preventDefault();
    }

    const window = getWindow();
    // window._sp_ starts as the inline SourcePoint config object; the usnat
    // API only exists once the wrapper script has finished loading
    if (
      isAuthenticated &&
      typeof window._sp_?.usnat?.loadPrivacyManagerModal === 'function'
    ) {
      // Show SourcePoint consent UI
      window._sp_.usnat.loadPrivacyManagerModal(
        Config.SOURCEPOINT_USNAT_PRIVACY_MANAGER_ID,
      );
    } else {
      // Show static Flipboard "Do Not Sell" modal
      showModal(DoNotSellModal);
    }
  };

  const handleClick = onClick
    ? (e) => {
        showDoNotSell(e);
        onClick(e);
      }
    : showDoNotSell;

  const linkProps = ObjectUtil.pick(
    Object.assign({}, props, { onClick: handleClick }),
    DNS_LINK_INCLUDE_PROPS,
  );

  if (auto) {
    showDoNotSell();
  }

  return <WebLink {...linkProps}>{label || t('do_not_sell')}</WebLink>;
}

DoNotSelLink.propTypes = {
  auto: PropTypes.bool,
  label: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  showModal: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  t: PropTypes.func.isRequired,
};

DoNotSelLink.defaultProps = {
  auto: false,
  onClick: null,
};

export default connector(
  connectModal,
  connectAuthentication,
)(withT(DoNotSelLink));
